const LoginMywishesConstants = {
	MW_LOGIN_REQUEST: "MW_LOGIN_REQUEST",
	MW_LOGIN_SUCCESS: "MW_LOGIN_SUCCESS",
	MW_LOGIN_FAILED: "MW_LOGIN_FAILED"
};

export { LoginMywishesConstants };
